<template>
    <div class='content'>
        <div class="con-1">
            <div class="con-2">{{ $t('content184') }}</div>
            <div class="con-3">
                {{ $t('content185') }}</div>
            <!-- <div class="btn-box">
                <div class="btn-blue">预约演示</div>
                <div class="btn-we">参观一下</div>
            </div> -->
            <img src="@/assets/guanyu_banner@2x.png" class="con-3-img" alt="">
        </div>

        <div :class="$i18n.locale + '_con-4'">
            <div class="con-5">
                <div class="con-6">{{ $t('content186') }}</div>
                <div class="con-7">
                    {{ $t('content187') }}</div>
                <div class="con-7">
                    {{ $t('content188') }}</div>
                <div class="con-7">
                    {{ $t('content189') }}</div>

            </div>
            <div :class="$i18n.locale + '_con-8'">
                <img :src="$i18n.locale == 'zh' ? require('@/assets/gushi_img@2x.png'):require('@/assets/en_gushi_img@2x.png')" class="con-8-img" alt="">
            </div>
        </div>
        <div class="con-9">
            {{ $t('content190') }}</div>
        <div class="con-10">
            <div class="con-11">
                <div>
                    <img :src="$i18n.locale == 'zh' ? require('@/assets/zidonghua_img@2x.png'): require('@/assets/en_zidonghua_img@2x.png')" class="con-11-img" alt="">
                </div>
                <div class="con-12">
                    {{ $t('content191') }}
                </div>
            </div>
            <div class="con-13">
                <div>
                    <img :src="$i18n.locale == 'zh' ? require('@/assets/quanchangjing_img@2x.png'):require('@/assets/en_quanchangjing_img@2x.png')" class="con-13-img" alt="">
                </div>
                <div class="con-14">
                     {{ $t('content192') }}
                </div>
            </div>
        </div>
        <div class="con-15">
            <div class="con-16">
                <div>
                    <img :src="$i18n.locale == 'zh' ? require('@/assets/api_img@2x.png'):require('@/assets/en_api_img@2x.png')" class="con-16-img" alt="">
                </div>
                <div class="con-17">
                    {{ $t('content193') }}
                </div>
            </div>
            <div class="con-18">
                <div>
                    <img :src="$i18n.locale == 'zh' ? require('@/assets/gaoxiao_img@2x.png'):require('@/assets/en_gaoxiao_img@2x.png')" class="con-16-img" alt="">
                </div>
                <div class="con-17">
                    {{ $t('content194') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//import

export default {
    name: 'regArding',
    components: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {},
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
}
</script>
<style scoped>
.con-1 {
    position: relative;
}

.con-2 {
    font-size: 36px;
    color: #333;
    position: absolute;
    top: 237px;
    left: 360px;
}

.con-3 {
    width: 484px;
    font-size: 22px;
    color: #666666;
    position: absolute;
    left: 360px;
    top: 306px;
    line-height: 32px;
}

.con-3-img {
    width: 100%;
    height: 750px;
}

.zh_con-4 {
    width: 100%;
    height: 750px;
    display: flex;
    margin-bottom: 134px;
}
.en_con-4 {
    width: 100%;
    height: 1000px;
    display: flex;
    margin-bottom: 134px;
}

.con-5 {
    width: 592px;
    margin-left: 360px;
    margin-top: 166px;
}

.btn-box {
    margin-top: 58px;
    text-align: center;
    display: flex;
    justify-content: center;
    margin-bottom: 49px;
    position: absolute;
    top: 435px;
    left: 360px;
}

.con-6 {
    font-size: 36px;
    color: #333333;
    margin-bottom: 23px;
    font-weight: 600;
}

.con-7 {
    font-size: 22px;
    color: #666666;
    line-height: 36px;
    width: 592px;
    margin-bottom: 20px;
}

.zh_con-8 {
    width: 600px;
    height: 600pt;
    margin-left: 40px;
    margin-top: 85px;
}
.en_con-8 {
    width: 600px;
    height: 600pt;
    margin-left: 40px;
    margin-top: 220px;
}


.con-8-img {
    width: 600px;
    height: 600px
}

.con-9 {
    font-size: 36px;
    color: #333;
    text-align: center;
    margin-top: -100px;
    margin-bottom: 65px;
    font-weight: 600;
}

.con-10 {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.btn-blue {
    width: 132px;
    height: 44px;
    font-size: 18px;
    background-color: #4873FF;
    color: #fff;
    border-radius: 5px;
    line-height: 44px;
    text-align: center;
    margin-right: 12px;
    cursor: pointer;

}

.con-11 {
    text-align: center;
    margin-bottom: 67px;
    margin-right: 74px;
}

.con-11-img {
    width: 570px;
    height: 360px;
}

.con-12 {
    font-size: 24px;
    color: #333;
    margin-top: 30px;
}

.con-13 {
    text-align: center;
    margin-bottom: 67px;
}

.con-13-img {
    width: 570px;
    height: 360px;
}

.con-14 {
    font-size: 24px;
    color: #333;
    margin-top: 30px;
}

.con-15 {
    display: flex;
    margin-bottom: 173px;
    justify-content: center;
}

.con-16 {
    text-align: center;
    margin-right: 74px;
}

.con-18 {
    text-align: center;
}

.con-16-img {
    width: 570px;
    height: 360px;
}

.con-17 {
    font-size: 24px;
    color: #333;
    margin-top: 30px;
}

.btn-we {
    width: 132px;
    height: 44px;
    font-size: 18px;
    background-color: #fff;
    color: #4873FF;
    border-radius: 5px;
    line-height: 44px;
    text-align: center;
    cursor: pointer;

    border: 1px solid #4873FF;
    margin-left: 12px;

}
</style>